import { useEffect, useState } from "react";
import { AdditionalDocumentDTO } from "../types/AdditionalDocumentDTO";
import { getAdditionalDocumentFile } from "../api/additionalDocuments";

export function useAdditionalDocumentPreview(
  companyId: string,
  document: AdditionalDocumentDTO | null
) {
  const [fileBase64, setFileBase64] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!document) {
      setFileBase64(null);
      return;
    }

    let mounted = true;

    async function load() {
      try {
        setLoading(true);
        setError(null);

        const base64 = await getAdditionalDocumentFile(
          companyId,
          document.SystemId
        );

        if (mounted) {
          setFileBase64(base64);
        }
      } catch (err: any) {
        if (mounted) {
          setError(err?.message ?? "Nie udało się wczytać pliku");
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    }

    load();

    return () => {
      mounted = false;
    };
  }, [companyId, document]);

  return {
    fileBase64,
    loading,
    error,
  };
}
